import { ReactElement, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonBatchManagementCrumbs } from '../constants';
import FormFunction, { BatchManagementForm } from 'system/components/batch-management/form';
import { useNavigate } from 'react-router-dom';
import { __OPERATION__BATCH__ } from 'shell/constants/environment';
// import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { toast } from 'react-toastify';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { requestTransformerBatchManagement } from '../utils/submit-request-transformer';

const BatchManagementNew = (): ReactElement => {
  const navigate = useNavigate();
  const insertJob = useHttpClient(`${__OPERATION__BATCH__}/jobs`, { options: { method: 'POST' } });

  const onOk = useCallback(
    (form: BatchManagementForm) => {
      const data = requestTransformerBatchManagement(form);
      (
        insertJob({
          data,
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/gestione-batch');
      });
    },
    [insertJob, navigate]
  );

  return (
    <>
      <Breadcrumbs items={[...CommonBatchManagementCrumbs, { name: 'Nuovo Batch' }]} />
      <FormFunction
        title="Nuovo Batch"
        onOk={onOk}
        onCancel={() => {
          navigate('/sistema/gestione-batch');
        }}
      />
    </>
  );
};

BatchManagementNew.displayName = 'BatchManagement New';

export default BatchManagementNew;
